require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-fleet-economic-4-x-4.json") })
        }
      }, "path---es-fleet-economic-4-x-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-fleet-economic-4-x-4!./.cache/json/es-fleet-economic-4-x-4.json
// module id = 1081
// module chunks = 231608221292675